import React, { FunctionComponent } from 'react';
import ElementWithTooltip from "../../components/ElementWithTooltip";

interface OwnProps {
  isVisible: boolean
  onClick: () => void
}

type Props = OwnProps;

const ZoomOutButton: FunctionComponent<Props> = (props) => {
  return (
    <ElementWithTooltip
      tooltip="Trip overview"
      tooltipPosition={"bottom"}
      offsetY="1rem"
      className={`mr-4 cursor-pointer z-30 transition-all transform ${props.isVisible ? "opacity-100" : "opacity-0"}`}
    >
      <svg
        onClick={props.onClick}
        xmlns="http://www.w3.org/2000/svg"
        className={"h-6 w-6"}
        fill="none" viewBox="0 0 24 24" stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
      </svg>
    </ElementWithTooltip>
  );
};

export default ZoomOutButton;
